// externals
import { connect } from 'react-redux';

// components
import TradeSummaryUI from './SummaryUI';

// interfaces/types
import { ITradeSummaryUIStateProps } from './SummaryUI';
import { IRootProps } from '../../../components';

// selectors
import * as tradeInSelectors from '../../../store/mmd/tradeIn';

const mapStateToProps = (state: any, ownProps: IRootProps): ITradeSummaryUIStateProps => {
    const { tradeIn } = tradeInSelectors.getTradeInState(state, ownProps.tradeIndex);
    const source = tradeIn?.source;

    return {
        source,
        tradeIndex: ownProps.tradeIndex
    };
};

const TradeSummary = connect(mapStateToProps)(TradeSummaryUI);

export default TradeSummary;
